/* eslint-disable */
import { TRASH_FILLED_24 } from "@sznds/icons";
import { IEvent } from "~/activerequest/interfaces";
import createSDSIcon from "~/ui/icon";
import { createRatingCard } from "~/ui/ratingcard";
import StarsBanner from "~/ui/stars-banner";
import { ONE_YEAR } from "~/util/constants";
import { node, text } from "~/util/dom";
import { STAR_16 } from "~/../node_modules/@sznds/icons/index";
import FirmReviewEdit from "~/review/edit";
import { putToCache } from "~/util/reviews-cache";
import { LOG_SOURCE } from "./constants";
import { getSignal } from "~/activerequest/util";
import { isTwin, getReviewConf } from "~/util/review";
import { IReviewItem, IReview } from "~/review/interfaces";
import { getDetail } from "~/util/providers/review";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";

interface ISuggestedUpdateItemOptions {
	event: IEvent;
	onReject: Function;
	onFinished: Function;
}

export default class SuggestedUpdateItem {
	#container: HTMLLIElement;
	#closeButton: HTMLButtonElement;
	#updateButton: HTMLButtonElement;
	#suggestion: HTMLDivElement;
	#onReject: Function;
	#onFinished: Function;
	#event: IEvent;
	#edit: FirmReviewEdit;

	constructor({
		event,
		onReject,
		onFinished,
	}: ISuggestedUpdateItemOptions) {
		this.#event = event;
		this.#container = node("li", { className: "suggestedupdateitem"});
		this.#suggestion = node("div", { className: "suggestedupdateitem__suggestion"});
		this.#onReject = onReject;
		this.#onFinished = onFinished;
		this.#edit = null;

		// obsah karty je vlastne jen hodnotici karta z aktivnich zadosti
		this.#suggestion.appendChild(createRatingCard({
			poi: {
				...event.data.poi.poiagg,
				review: event.review_data || event.review,
			},
			onPOIClick: () => {
				Mapy.getComponent("detail").setState({
					source: event.data.poi.source,
					id: event.data.poi.id,
					backTitle: _("mymap.switcher.reviews"),
				}).then(() => {
					Mapy.getComponent("history").save();
				}, () => {});

				Mapy.getComponent("logger").log("click", {
					text: "updateGoToDetail",
					section: "suggestionDashboard",
					signal: getSignal(this.#event),
				});
			},
		}));

		// otazka
		const revisited = node("p", { className: "suggestedupdateitem__revisited", innerHTML: _("mymap.reviews.revisited") });

		this.#suggestion.appendChild(revisited);

		// hvezdicky a datum
		const top = node("div", { className: "suggestedupdateitem__top" });
		const rating = new StarsBanner({
			percentage: event.review.reviewPercentage || event.review.rating,
		});
		const reviewDate = new Date(event.review.reviewDate || event.review.updated);
		const time = node("h2", { innerHTML: new Intl.DateTimeFormat(CONFIG.defaultLang, { year: "numeric", month: "long", day: "numeric" }).format(reviewDate) + (reviewDate.getTime() + ONE_YEAR < new Date().getTime() ? ` (${_("mymap.reviews.aYearAgo")})` : "") });

		top.appendChild(rating.container);
		top.appendChild(time);
		this.#suggestion.appendChild(top);

		// text
		const reviewText = event.review.reviewText || event.review.text;

		if (reviewText) {
			const text = node("p", { className: "suggestedupdateitem__text", innerHTML: Mapy.Util.escapeHTML(reviewText) });

			this.#suggestion.appendChild(text);
		}

		// tlacitko pro aktualizaci
		this.#updateButton = node("button", { type: "button", className: "suggestedupdateitem__updateButton" });
		this.#updateButton.appendChild(createSDSIcon({
			symbol: STAR_16,
		}));
		this.#updateButton.appendChild(text(_("mymap.reviews.updateReview")));
		this.#suggestion.appendChild(this.#updateButton);
		this.#updateButton.addEventListener("click", this);

		// zaviraci tlacitko
		this.#closeButton = node("button", { type: "button", className: "suggestedupdateitem__closeButton" });
		this.#closeButton.appendChild(createSDSIcon({
			symbol: TRASH_FILLED_24,
		}));
		this.#closeButton.addEventListener("click", this);
		this.#suggestion.appendChild(this.#closeButton);

		this.#container.appendChild(this.#suggestion);
	}

	get node() {
		return this.#container;
	}

	destroy() {
		this.#closeButton.removeEventListener("click", this);
	}

	handleEvent(event) {
		switch (true) {
			case this.#closeButton.contains(event.target):
				this.#onReject && this.#onReject();
				break;

			case this.#updateButton.contains(event.target):
				this.#openReview();
		}
	}

	async #openReview() {
		try {
			const detailData = await getDetail({ source: this.#event.data.poi.source, id: this.#event.data.poi.id });

			this.#edit = new FirmReviewEdit({
				data: {
					...getReviewConf(detailData.poi),
					title: this.#event.data.poi.poiagg.titleVars.titleSmartMain,
					myReview: detailData.myReview || {
						actual: true,
						updated: new Date().toString(),
						id: 0,
						gallery: [],
						rating: this.#event.review.reviewPercentage || this.#event.review.rating || 20,
						state: "new",
						weight: 0,
						text: this.#event.review.reviewText || this.#event.review.text || "",
						type: "firm",
						review_source: "mapy-web",
						rejectReason: "",
					},
				},
				logSource: LOG_SOURCE,
				analytics: {
					type: "recenze-update",
					signal: getSignal(this.#event),
					source: LOG_SOURCE,
					section: "suggestionDashboard",
					rating_layout: "0",
					position: "top",
					sourcePoi: detailData.poi.source,
					typeid: detailData.poi.typeId,
					firmTwin: isTwin(detailData.poi) ? 1 : 0,
				},
				thankYouCont: this.#container,
				update: true,
				onSave: ({
					myReview,
				}: {
					review: IReview,
					myReview: IReviewItem,
				}) => {
					putToCache(this.#event.data.poi, myReview);
					this.#closeReview();
					this.#onFinished && this.#onFinished();
				},
				onCancel: () => {
					this.#closeReview();
				}
			});

			this.#suggestion.remove();
			this.#edit.openEdit();
		} catch (exc) {
			console.log(exc);
			this.#closeReview();
		}
	}

	#closeReview() {
		if (this.#edit) {
			this.#container.appendChild(this.#suggestion);
			this.#edit.destroy();
			this.#edit = null;
		}
	}
}
